import { Component, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

import { AuthService } from '../../../auth/auth.service';
import { MenuService } from '../menu.service';
import { ValidacionesService } from '../../validaciones/validaciones.service';
import { Validacion } from '../../../../asistente-en-linea/models/Validacion';
import { logging } from 'protractor';
import { TipoValidacion } from '../../../../asistente-en-linea/models/TipoValidacion';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-validaciones-menu',
  templateUrl: './validaciones-menu.component.html',
  styleUrls: ['./validaciones-menu.component.scss']
})
export class ValidacionesMenuComponent implements OnInit {
  cargandoDatos: boolean;
  tiposValidaciones: TipoValidacion[];
  validaciones: Validacion[];
  validacionesMenuSeleccionados: Number[];
  asistentemenu: string;
  descripcion: string;
  loading: boolean;
  displayedColumns = ['select', 'nombre','tipo','habilitado'];
  dataSource: any;
  selection: any;
  initialSelection: any;
  allowMultiSelect: boolean;
  @ViewChild(MatPaginator, { static: true }) paginatorTipos: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private validacionesService: ValidacionesService, private menuService: MenuService, private route: ActivatedRoute, private router: Router, private authService: AuthService) {
    this.loading = false;
    this.initialSelection = [];
    this.allowMultiSelect = true;
    this.selection = new SelectionModel<Validacion>(this.allowMultiSelect, this.initialSelection);
    this.asistentemenu = "1";
  }



  ngOnInit() {
    this.dataSource = new MatTableDataSource([]);

    this.route.queryParamMap.subscribe((params: any) => {
      this.asistentemenu = params.params.idAsistente;
      this.loadValidaciones();
    })
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  async loadValidaciones() {
    this.validaciones = [];

    this.loading = true;

    let resArray = [];
    this.loading = true;
    resArray.push(await this.validacionesService.loadValidaciones(false).toPromise().catch((err) => {
      this.loading = false;
      alert(err);
    }));

    let noErr = resArray.reduce((previous, current) => {
      if (previous && (current.statusCode == 200 || current.statusCode == 0)) {
        const resultado = current.content;
        if (resultado.length > 0) {
          for (let m of resultado) {
            let val = new Validacion(
              m.id,
              m.codigo,
              m.nombre,
              m.tipo,
              "",
               "",
              "",
              m.habilitado
            );
            this.validaciones.push(val);
          }
        }
        return true;
      }
      return false;
    }, true);

    if (noErr) {
      this.dataSource = new MatTableDataSource(this.validaciones);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      
      let resArray = [];
      resArray.push(await this.menuService.loadValidacionesMenu(this.asistentemenu, false).toPromise().catch((err) => {
        alert(err);
      }));

      let noErr = resArray.reduce((previous, current) => {
        if (previous && (current.statusCode == 200 || current.statusCode == 0)) {
          const resultado = current.content;
          this.descripcion = current.nombreAsistente;
          if (resultado.length > 0) {
            for (let m of resultado) {
              this.dataSource.data.forEach(row => {
                if (row.id == m) {
                  this.selection.toggle(row);
                  this.selection.isSelected(row)
                  this.selection.select(row);
                  return;
                }
              });
            }
          }
          return true;
        }
        return false;
      }, true);

      if (!noErr) {
        alert("Ocurrió un error, intente nuevamente más tade");
      } 
    }
  }


  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }

  cancelOperation() {
    this.irPaginaInicio();
  }
  async applyOperation() {
    this.loading = true;
    this.validacionesMenuSeleccionados = [];

    this.selection._selection.forEach((item) => {
      this.validacionesMenuSeleccionados.push(item.id)
    });
    
    let resArray = [];
    resArray.push(await this.menuService.guardarValidacionesMenu(this.asistentemenu, this.authService.getUser().username, this.validacionesMenuSeleccionados).toPromise().catch((err) => {
      //alert(err);
    }));

    let noErr = resArray.reduce((previous, current) => {
      return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
    }, true)

    if (noErr) {
      this.irPaginaInicio();
    } else {
      alert("Ocurrió un error, intente nuevamente más tade");
    }
    this.loading = false;  
  }
}